import { Panel, Chip, Kpi } from "@/components/common";
import { fmt } from "@/lib/api";

export function SignalBanner({ s }) {
  const sig = s.last_signal || "NONE";
  const b = s.bands || {};
  const tone = sig === "LONG" ? "border-emerald-500/40 bg-emerald-500/10" : sig === "SHORT" ? "border-rose-500/40 bg-rose-500/10" : "border-slate-800 bg-slate-900/80";
  const title = sig === "LONG" ? "LONG SPREAD (buy Brent, sell WTI)" : sig === "SHORT" ? "SHORT SPREAD (sell Brent, buy WTI)" : b.ready ? "No signal" : "Warming up";
  const sub = b.ready
    ? `z ${fmt(s.z)}, SMA ${fmt(b.sma, 3)}, bands ${fmt(b.lower, 3)} to ${fmt(b.upper, 3)}`
    : `Collecting bars: ${b.bars || 0} of ${b.need || s.config.sma_period_bars}. No signal until the window is full.`;
  return (
    <div data-testid="oil-signal-banner" className={`fade-up flex flex-wrap items-center justify-between gap-3 rounded-lg border px-5 py-4 ${tone}`}>
      <div>
        <div className="flex items-center gap-2"><Chip status={sig} testid="oil-signal-chip" /><span className="font-display text-xl font-bold text-slate-100" data-testid="oil-signal-title">{title}</span></div>
        <div className="num mt-1 text-xs text-slate-400" data-testid="oil-signal-subtitle">{sub}</div>
      </div>
      <div className="text-right">
        <Chip status={s.session.entries ? "ON" : "OFF"} label={s.session.label} testid="oil-session-badge" />
        <div className="num mt-1 text-[11px] text-slate-500">London {s.london_time}</div>
      </div>
    </div>
  );
}

export function KpiStrip({ s }) {
  const b = s.bands || {};
  const z = s.z;
  return (
    <Panel testid="oil-kpi-strip">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        <Kpi label="Spread" value={fmt(s.spread, 3)} testid="oil-kpi-spread" sub={`Brent ${fmt(s.brent)} / WTI ${fmt(s.wti)}`} />
        <Kpi label={`SMA ${s.config.sma_period_bars}`} value={b.ready ? fmt(b.sma, 3) : "-"} testid="oil-kpi-sma" className="text-amber-300" />
        <Kpi label={`Upper +${s.config.stddev_mult}σ`} value={b.ready ? fmt(b.upper, 3) : "-"} testid="oil-kpi-upper" className="text-rose-300" />
        <Kpi label={`Lower -${s.config.stddev_mult}σ`} value={b.ready ? fmt(b.lower, 3) : "-"} testid="oil-kpi-lower" className="text-emerald-300" />
        <Kpi label="z-score" value={z == null ? "-" : fmt(z)} testid="oil-kpi-z" className={z > 0 ? "text-rose-300" : z < 0 ? "text-emerald-300" : ""} />
        <Kpi label="Bars" value={`${b.bars || 0} / ${b.need || s.config.sma_period_bars}`} testid="oil-kpi-bars" sub={`${s.config.bar_interval_sec}s bars`} />
      </div>
    </Panel>
  );
}
